import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["columns", "checkboxCellStyle", "isSelected", "toggleSelection", "toggleAll", "keyField", "selectAll", "selectType", "selectWidth", "SelectAllInputComponent", "SelectInputComponent"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash';
import { Checkbox } from 'antd';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import _has from 'lodash/has';
import styles from './table.module.scss';
var ColumnCheckbox = function ColumnCheckbox(_ref) {
  var checked = _ref.checked,
    onClick = _ref.onClick,
    id = _ref.id,
    row = _ref.row,
    indeterminate = _ref.indeterminate,
    disabled = _ref.disabled,
    wrapperClassName = _ref.wrapperClassName;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onCheckBoxClick(onClick, id, row),
    className: wrapperClassName
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: checked,
    disabled: disabled,
    className: "checkbox",
    indeterminate: indeterminate
  }));
};
var onCheckBoxClick = function onCheckBoxClick(onClick, id, row) {
  return function (event) {
    event.stopPropagation();
    var shiftKey = event.shiftKey;
    onClick(id, shiftKey, row);
  };
};
export default (function (Component) {
  var wrapper = /*#__PURE__*/function (_React$Component) {
    _inherits(RTSelectTable, _React$Component);
    var _super = _createSuper(RTSelectTable);
    function RTSelectTable() {
      _classCallCheck(this, RTSelectTable);
      return _super.apply(this, arguments);
    }
    _createClass(RTSelectTable, [{
      key: "getWrappedInstance",
      value:
      // this is so we can expose the underlying ReactTable to get at the sortedData for selectAll
      function getWrappedInstance() {
        if (!this.wrappedInstance) console.warn('RTSelectTable - No wrapped instance');
        if (this.wrappedInstance.getWrappedInstance) return this.wrappedInstance.getWrappedInstance();
        return this.wrappedInstance;
      }
    }, {
      key: "headSelector",
      value: function headSelector() {
        var _this$props = this.props,
          toggleAll = _this$props.toggleAll,
          checked = _this$props.selectAll,
          SelectAllInputComponent = _this$props.SelectAllInputComponent,
          noHeadSelector = _this$props.noHeadSelector,
          indeterminate = _this$props.indeterminate;
        if (noHeadSelector) {
          return null;
        }
        var wrapperClassName = 'cursor-pointer';
        var inputProps = {
          checked: checked,
          onClick: toggleAll,
          indeterminate: indeterminate,
          wrapperClassName: wrapperClassName
        };
        return /*#__PURE__*/React.createElement(SelectAllInputComponent, inputProps);
      }
    }, {
      key: "rowSelector",
      value: function rowSelector(row) {
        var _this$props2 = this.props,
          isSelected = _this$props2.isSelected,
          isDisabled = _this$props2.isDisabled,
          keyFieldFromProps = _this$props2.keyField,
          SelectInputComponent = _this$props2.SelectInputComponent;
        if (!row || !_has(row, keyFieldFromProps)) return null;
        var _this$props3 = this.props,
          toggleSelection = _this$props3.toggleSelection,
          keyField = _this$props3.keyField;
        var checked = isSelected(row[keyFieldFromProps]);
        var disabled = isDisabled(row[keyFieldFromProps]);
        var wrapperClassName = 'full-height full-width flex-center cursor-pointer';
        var inputProps = {
          checked: checked,
          onClick: toggleSelection,
          id: row[keyField],
          row: row,
          indeterminate: row.isIndeterminate,
          disabled: disabled,
          wrapperClassName: wrapperClassName
        };
        return /*#__PURE__*/React.createElement(SelectInputComponent, inputProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;
        var _this$props4 = this.props,
          originalCols = _this$props4.columns,
          checkboxCellStyle = _this$props4.checkboxCellStyle,
          isSelected = _this$props4.isSelected,
          toggleSelection = _this$props4.toggleSelection,
          toggleAll = _this$props4.toggleAll,
          keyField = _this$props4.keyField,
          selectAll = _this$props4.selectAll,
          selectType = _this$props4.selectType,
          selectWidth = _this$props4.selectWidth,
          SelectAllInputComponent = _this$props4.SelectAllInputComponent,
          SelectInputComponent = _this$props4.SelectInputComponent,
          rest = _objectWithoutProperties(_this$props4, _excluded);
        var select = {
          id: '_selector',
          accessor: function accessor() {
            return 'x';
          },
          // this value is not important
          Header: this.headSelector.bind(this),
          Cell: function Cell(ci) {
            return _this.rowSelector.bind(_this)(ci.original);
          },
          width: selectWidth || 50,
          filterable: false,
          sortable: false,
          resizable: false,
          style: _objectSpread({
            alignSelf: 'center',
            padding: 0
          }, checkboxCellStyle),
          fixed: 'left',
          className: styles.checkBoxCell
        };
        var columns = [select].concat(_toConsumableArray(originalCols));
        var extra = {
          columns: columns
        };
        return /*#__PURE__*/React.createElement(Component, _extends({}, rest, extra, {
          ref: function ref(r) {
            _this.wrappedInstance = r;
          }
        }));
      }
    }]);
    return RTSelectTable;
  }(React.Component);
  wrapper.displayName = 'RTSelectTable';
  wrapper.defaultProps = {
    selectType: 'checkbox',
    checked: false,
    checkboxCellStyle: EMPTY_OBJECT,
    onClick: _noop,
    id: '',
    row: {},
    keyField: 'id',
    isSelected: function isSelected(key) {
      console.log('No isSelected handler provided:', {
        key: key
      }); // eslint-disable-line
    },

    isDisabled: function isDisabled(key) {
      console.log('No isDisabled handler provided:', {
        key: key
      }); // eslint-disable-line
    },

    selectAll: false,
    toggleSelection: function toggleSelection(key, shift, row) {
      console.log('No toggleSelection handler provided:', {
        key: key,
        shift: shift,
        row: row
      }); // eslint-disable-line
    },

    toggleAll: function toggleAll() {
      console.log('No toggleAll handler provided.'); // eslint-disable-line
    },

    SelectInputComponent: ColumnCheckbox,
    SelectAllInputComponent: ColumnCheckbox
  };
  ColumnCheckbox.propTypes = {
    checked: PropTypes.bool,
    onClick: PropTypes.func,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    row: PropTypes.any
  };
  ColumnCheckbox.defaultProps = {
    checked: false,
    onClick: _noop,
    id: '',
    row: {}
  };
  return wrapper;
});